import React from 'react'
import { useEffect } from 'react';
import { useDetectIOS } from "./useDetectIOS";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Logo from './../Public/Image/ios/logo.png'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined'; import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IosShareIcon from '@mui/icons-material/IosShare';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '75%',
    height: '75vh',
    bgcolor: 'background.paper',
    maxWidth:'400px',
    borderRadius:"20px",
    //   border: '2px solid #fff',
    // boxShadow: 24,
    p: 4,
     border: 'none',          // حذف border احتمالی
      boxShadow: 'none',       // حذف box-shadow
      outline: 'none',         // حذف focus outline
      '&:focus': { outline: 'none' },
  
};
const DetectIOSWrapper = () => {
    const isIOS = useDetectIOS();


    const [open, setOpen] = React.useState(true);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    //   useEffect(() => {
    //     !isIOS ? setOpen(true) : null
    // }, [])
    return (
        <>
            {isIOS ?
                <>
                    {/* <Button onClick={handleOpen}>Open modal</Button> */}
                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                          scroll="paper" // 👈 این گزینه کلیدیه!

                    >
                        <Box sx={style}>
                            <div className='ModalForIos'>
                                <img src={Logo} width={72} height={96} />
                                <h1 className='ModalForIosH1'>
                                    Add Membersgram
                                    to Your Home Screen
                                </h1>




                                <ul className='ModalForIosUl'>
                                    <li>Launch Membersgram like a native app</li>
                                    <li>Stays up to date automatically</li>
                                    <li>Works fullscreen and keeps you signed in</li>
                                </ul>
                                <ol className='ModalForIosOl'>
                                    <li>
                                        <div className='ModalForIosOlInner'> Tap on  <PendingOutlinedIcon className='ModalForIosOlInnerIcon' />     button</div>
                                    </li>
                                    <li>
                                        <div className='ModalForIosOlInner'>Tap the    <IosShareIcon className='ModalForIosOlInnerIcon' />   Share button</div>
                                    </li>
                                    <li>
                                        <div className='ModalForIosOlInner'>Tap on   <MoreHorizIcon className='ModalForIosOlInnerIcon' />    More Button</div>
                                    </li>
                                    <li>
                                        Choose Add to Home Screen.
                                    </li>
                                    <li>
                                        <div className='ModalForIosOlInner'>Tap <AddBoxOutlinedIcon className='ModalForIosOlInnerIcon' />     Add to confirm.</div>
                                    </li>
                                </ol>
                                <button onClick={() => setOpen(false)} className='ModalForIosButton'>
                                    Got it
                                </button>
                            </div>

                            {/* <Typography id="modal-modal-title" variant="h6" component="h2">
                                Text in a modal
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                            </Typography> */}
                        </Box>
                    </Modal>
                </>
                :
                //  <>
                //     {/* <Button onClick={handleOpen}>Open modal</Button> */}
                //     <Modal
                //         open={open}
                //         onClose={handleClose}
                //         aria-labelledby="modal-modal-title"
                //         aria-describedby="modal-modal-description"
                //     >
                //         <Box sx={style}>
                //             <div className='ModalForIos'>
                //                 <img src={Logo} width={72} height={96} />
                //                 <h1 className='ModalForIosH1'>
                //                     Add Membersgram
                //                     to Your Home Screen
                //                 </h1>




                //                 <ul className='ModalForIosUl'>
                //                     <li>Launch Membersgram like a native app</li>
                //                     <li>Stays up to date automatically</li>
                //                     <li>Works fullscreen and keeps you signed in</li>
                //                 </ul>
                //                 <ol className='ModalForIosOl'>
                //                     <li>
                //                         <div className='ModalForIosOlInner'> Tap on  <PendingOutlinedIcon className='ModalForIosOlInnerIcon' />     button</div>
                //                     </li>
                //                     <li>
                //                         <div className='ModalForIosOlInner'>Tap the    <IosShareIcon className='ModalForIosOlInnerIcon' />   Share button</div>
                //                     </li>
                //                     <li>
                //                         <div className='ModalForIosOlInner'>Tap on   <MoreHorizIcon className='ModalForIosOlInnerIcon' />    More Button</div>
                //                     </li>
                //                     <li>
                //                         Choose Add to Home Screen.
                //                     </li>
                //                     <li>
                //                         <div className='ModalForIosOlInner'>Tap <AddBoxOutlinedIcon className='ModalForIosOlInnerIcon' />     Add to confirm.</div>
                //                     </li>
                //                 </ol>
                //                 <button onClick={() => setOpen(false)} className='ModalForIosButton'>
                //                     Got it
                //                 </button>
                //             </div>

                //             {/* <Typography id="modal-modal-title" variant="h6" component="h2">
                //                 Text in a modal
                //             </Typography>
                //             <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                //                 Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                //             </Typography> */}
                //         </Box>
                //     </Modal>
                // </>
                null
            }
        </>
    )
}

export default DetectIOSWrapper